var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('bread-crumb'),_vm._v(" "),_c('main-content',{attrs:{"surveyInfo":_vm.surveyInfo,"loading":_vm.loading},on:{"delete":_vm.handleDelete,"update":_vm.handleUpdate,"refresh":_vm.handleRefresh,"search":_vm.handleSearch}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b2b5e34","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/authority/Authority.vue
// module id = null
// module chunks = 